<template>
	<div>
		<div :class="tableSmall ? 'm-0' : (small ? 'm-1' : 'm-3')"><div :style="imagesTool.avatar(src, tableSmall ? 2 : (small ? 2.5 : 10.6))"></div></div>
	</div>
</template>

<script>
import imagesTool from '@/tools/images';

export default {
	name: 'replacement-vehicle-image',
	methods: {
		
	},
	props: {
		small: {
			type: Boolean,
			default: false
		},
		tableSmall: {
			type: Boolean,
			default: false
		},
		image: {
			type: String,
			default: null
		}
	},
	data: function () {
		return {
			imagesTool
		};
	},
	computed: {
		src () {
			return this.image ?? './replacement_vehicle_default.png';
		},
	}
};
</script>